var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-loading-wrapper"},[_c('div',{staticClass:"custom-progress"},[_c('div',{staticClass:"custom-progress-indicator"})])])
}]

export { render, staticRenderFns }